var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "root",
      class: { gradient: _vm.gradient },
      on: {
        click: function($event) {
          _vm.$emit("onClick")
        }
      }
    },
    [
      _c("div", { staticClass: "outside-header" }, [
        _vm._v("\n    " + _vm._s(_vm.header) + "\n  ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-content",
          class: { "card-content-inverted": _vm.inverted }
        },
        [
          _c(
            "div",
            {
              staticClass: "text-content",
              class: { "text-content-inverted": _vm.inverted }
            },
            [
              _c("div", { staticClass: "inside-header" }, [
                _vm._v("\n        " + _vm._s(_vm.header) + "\n      ")
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text" }, [
                _vm._v("\n        " + _vm._s(_vm.text) + "\n      ")
              ])
            ]
          ),
          _vm._v(" "),
          _c("img", { attrs: { src: _vm.imagePath } })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6f791954", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f791954","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/components/InfoCards/cards/Card.vue
// module id = null
// module chunks = 